<template>
    <div id="index">
        <div class="ui middle aligned center aligned grid">
            <div class="column">
                <h1 class="ui header">
                    <i class="icons">
                        <i class="red remove user large icon"></i>
                        <span>
                            <!-- 您無權限 -->
                            {{ $t("ui.pages.partials.permission_denied.you_dont_permission") }}
                        </span>
                    </i>
                </h1>
                <h2 class="ui header" v-if="back_two_page[1]">
                    {{ $t('ui.general.cannot_use') }}
                    {{ $t('ui.page_titles.' + back_two_page[0].name) }}
                    {{ $t('page') }}
                    <br>
                    <br>

                    <router-link :to="{name: back_two_page[1].name}"
                        v-if="back_two_page[1].name != 'permission_denied'"
                        class="ui big button">
                        {{ $t('ui.general.back') }} {{ $t('ui.page_titles.' + back_two_page[1].name) }}
                    </router-link>

                    <router-link :to="{name: 'provider_index'}"
                        v-else
                        class="ui big button">
                        {{ $t('ui.general.back') }}
                        {{ $t('ui.page_titles.index') }}
                    </router-link>

                </h2>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
    },
    data() {
        return {
            is_loading: false
        }
    },
    mounted() {
        if (this.$store.state.back_two_page.length == 1) {
            this.$router.push('/provider/')
        }
    },
    watch: {
    },
    computed: {
        back_two_page() {
            // console.log(this.$store.state.back_two_page)
            return this.$store.state.back_two_page
        },
    },
    methods: {

    },
    components: {

    },
}
</script>

<style lang="scss" scoped>
    .icons span {
        font-style: initial;
        vertical-align: -webkit-baseline-middle;
        vertical-align: -moz-middle-with-baseline;
    }
    i.icons .icon:first-child {
        vertical-align: -webkit-baseline-middle;
        vertical-align: -moz-middle-with-baseline;
        width: 36px;
    }
</style>
